import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { homeApi } from 'api/homeApi';
import HomeSlice from './slice/HomeSlice';

const reducer = combineReducers({
    home: HomeSlice,
    [homeApi.reducerPath]: homeApi.reducer,
});

const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        })
            .concat(homeApi.middleware)
});
export default store;
